import { render } from "./orderFrom.vue?vue&type=template&id=4de520c8&scoped=true"
import script from "./orderFrom.vue?vue&type=script&lang=js"
export * from "./orderFrom.vue?vue&type=script&lang=js"

import "./orderFrom.vue?vue&type=style&index=0&id=4de520c8&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de520c8"]])

export default __exports__